import { useState } from "react";
import { useResource } from "Translations/Resources";
import { MerchantNotesForm } from "Components/Hunter/Merchants/CompleteRegistration/Tabs/MerchantNotes/MerchantNotesForm";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import { Resources } from "Translations/Resources";

const FORM_ID = "editable-notes";
const RESOURCES = Resources.Hunter.Merchants.CompleteRegistration.Notes;

type Props = {
  merchantPublicID: string;
  notes?: string | null;
  isReadOnly?: boolean;
};

export const EditableNotes = ({
  merchantPublicID,
  notes,
  isReadOnly = false,
}: Props) => {
  const [isEditing, setIsEditing] = useState(false);
  const { t } = useResource();

  const defaultValues = { note: notes ?? "" };

  if (isEditing) {
    return (
      <Stack gap={2}>
        <MerchantNotesForm
          formId={FORM_ID}
          merchantPublicID={merchantPublicID}
          defaultValues={defaultValues}
          onAfterSubmit={() => setIsEditing(false)}
        />
        <FormButtons formId={FORM_ID} onCancel={() => setIsEditing(false)} />
      </Stack>
    );
  }

  return (
    <ValuesBox
      title={t(RESOURCES.Title)}
      onEdit={isReadOnly ? undefined : () => setIsEditing(true)}
    >
      <Typography
        fontWeight={400}
        fontSize="1rem"
        sx={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {notes || t(RESOURCES.NoNotes)}
      </Typography>
    </ValuesBox>
  );
};

type FormButtonsProps = {
  onCancel: () => void;
  formId: string;
};

const FormButtons = ({ onCancel, formId }: FormButtonsProps) => {
  const { t } = useResource();

  return (
    <Box display="flex" justifyContent="flex-end" gap={2}>
      <Button type="button" variant="text" onClick={onCancel}>
        {t(Resources.Common.Cancel)}
      </Button>
      <Button
        type="submit"
        form={formId}
        variant="contained"
        sx={({ palette }) => ({
          "&.Mui-disabled": {
            color: palette.common.white,
            background: palette.action.disabledBackground,
          },
        })}
      >
        {t(Resources.Common.Save)}
      </Button>
    </Box>
  );
};
